import { toast } from "react-toastify";
import TOASTER from "../config/toaster";
import { ERR_NETWORK, ERR_TIME_OUT } from "../enums";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

export const handleErrorMessage = (
  error,
  showToaster = false,
  toastId = ""
) => {
  let message = "Internal server error. Please try again later.";

  if (error?.message === "canceled") return;

  if (error?.status === 403) return "You don't have permission to perform this action!";

  if (error?.response) {
    const data = error.response?.data;

    if (data?.errors && typeof data.errors === "object") {
      const messages = Object.values(data.errors)
        .flat()
        .map((msg) => msg.trim().replace(/\.$/, ""));
      message = messages.join(". ") + ".";
    } else if (data?.message) {
      message = data.message;
    } else if (data?.error) {
      message = data.error;
    } else if (!data || Object.keys(data).length === 0) {
      message = `API Request failed`;
    } else if (data && data.length < 200) {
      message = data;
    }
  } else if (error instanceof InteractionRequiredAuthError) {
    // User session expired in Azure AD; re-authentication required
    message = "Session expired; please log in again.";
  } else if (error?.message && typeof error.message === "string") {
    // Handle standard Error objects (like those from fetch API)
    message = error.message;
  } else if (error?.code === ERR_NETWORK) {
    message =
      "No response received from the server. Please check your connection.";
  } else if (error?.code === ERR_TIME_OUT) {
    message = "The request timed out. Please try again.";
  }

  if (showToaster && !toastId) {
    toast.error(message, {
      autoClose: TOASTER.ERROR_AUTO_CLOSE, // 7 seconds for errors
    });
  }

  if (showToaster && toastId) {
    toast.update(toastId, {
      render: message,
      type: "error",
      isLoading: false,
      autoClose: TOASTER.ERROR_AUTO_CLOSE, // 7 seconds for errors
    });
  }

  return message;
};
